import { getHost, HOSTS } from "../../plugins/analytics";

export const SHELL_APP_HEADER_ICON = {
  CROSS: "CROSS",
  BACK: "BACK",
};

export default {
  computed: {
    /**
     * @returns true if the host is ShellApp else returns false if it is a browser.
     */
    isShellApp() {
      return getHost() === HOSTS.SHELL_APP;
    },
  },
  methods: {
    /**
     * @param {string} actionType the type of action to be performed by the Shell App
     * (for example initiating otp detection or forwarding clvertap events)
     * @param {any} actionData the data that is necessary to perform the above action
     *
     * Shell App will receive these values in the onMessage() handler of the webview
     */
    sendPostMessageToShellApp(actionType, actionData = {}) {
      if (this.isShellApp) {
        const msg = {
          // identifier to let the host know that this post message is not
          // the default one it generally gets on navigation state change
          isMessageFromWebContext: true,
          actionType: actionType,
          ...actionData,
        };
        window.ReactNativeWebView.postMessage(JSON.stringify(msg));
      }
    },

  },
};
